import React, { 
  useEffect, 
  useState, 
  createContext, 
  useContext 
} from "react";

const NetworkContext = createContext();

export const useNetworkStatus = () => useContext(NetworkContext);

const NetworkProvider = ({ children }) => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const updateNetworkStatus = () => {
      setIsOnline(navigator.onLine);
      
    };

    const handleOnline = () => {
        setIsOnline(true);
    }
    const handleOffline = () => setIsOnline(false);

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []); 
  const renderOfflineBanner = () => (
    <div className="fixed top-0 left-0 w-full bg-red-600 text-white text-center py-2 z-50 shadow">
      ⚠️ You are offline. Check Your Internet Connection .
    </div>
  );

  return (
    <NetworkContext.Provider value={{ isOnline }}>
      {!isOnline && renderOfflineBanner()}
      {children}
    </NetworkContext.Provider>
  );
};

export default NetworkProvider;